import './sentry';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { LAZY_RETRY_FLAG_KEY } from './helpers/lazyWithRetry';
import { startAppViewportHeight } from './helpers/appViewportHeight';

startAppViewportHeight();

// Vite dispara este evento cuando falla la precarga de un chunk JS/CSS con
// carga diferida (despliegue viejo con hash obsoleto, o interferencia de un
// bloqueador de anuncios/privacidad en el navegador del visitante — confirmado
// en Sentry: peticiones a analytics.google.com bloqueadas en la misma sesión
// que el CSS). Recargamos para que el visitante se recupere solo, y con
// preventDefault() evitamos que Vite relance el error original después del
// evento — si no, Sentry lo reporta como "unhandled" en cada intento aunque
// ya lo estemos manejando aquí.
//
// Comparte la bandera con lazyWithRetry (mismo problema de fondo, dos formas
// de manifestarse: acá la promesa del chunk se RECHAZA, en lazyWithRetry se
// RESUELVE con undefined): un solo recargo automático permitido por pestaña
// entre ambos mecanismos, para no entrar en bucle infinito si el bloqueo
// persiste tras recargar.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();

  const alreadyReloaded = sessionStorage.getItem(LAZY_RETRY_FLAG_KEY) === '1';
  if (alreadyReloaded) {
    // Ya intentamos recuperarnos recargando una vez y el problema sigue:
    // no seguimos en bucle. Sentry ya capturó el error original de todos
    // modos (preventDefault solo evita que Vite lo relance encima).
    return;
  }

  sessionStorage.setItem(LAZY_RETRY_FLAG_KEY, '1');
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>,
);
